import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdIcon } from "../generic/icon/IdIcon";
export var IdTradePanelTab;
(function (IdTradePanelTab) {
    IdTradePanelTab["Buy"] = "Buy";
    IdTradePanelTab["Sell"] = "Sell";
})(IdTradePanelTab || (IdTradePanelTab = {}));
export var UiDefinitionTabBuy = {
    icon: IdIcon.CartIcn,
    id: IdTradePanelTab.Buy,
    locaKey: IdLoca.buy,
};
export var UiDefinitionTabSell = {
    icon: IdIcon.RegisterIcn,
    id: IdTradePanelTab.Sell,
    locaKey: IdLoca.sell,
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/UIDefinitionTradePanel.ts
// module id = 930
// module chunks = 3